<template>
  <div v-show="!imageLoading && showImages && image" class="img-container">
    <img
      v-if="image?.height && image?.width"
      :src="image?.url"
      :height="image?.height"
      :width="image?.width"
      class="m-0"
      :alt="image?.alt"
    />
    <img v-else :src="image?.url" class="m-0" :alt="image?.alt" />
  </div>

  <LoadingComponent v-if="imageLoading || !showImages" />
</template>

<script lang="ts">
import { defineComponent, watch, PropType, ref } from 'vue'
import LoadingComponent from '~conciergeUiCommons/components/LoadingComponent.vue'
import { useImage } from '@vueuse/core'
import { AsyncImageData } from '~conciergeUiCommons/composables/showImage'

export default defineComponent({
  setup(props, { emit }) {
    const imageLoading = ref<boolean>(true)
    const imageError = ref<unknown | Event>()
    if (props.image) {
      if (props.image.index == props.currentImageIndexToLoad) {
        const { isLoading, isReady, error } = useImage({ src: props.image.url })
        imageError.value = error
        watch(isLoading, () => {
          imageLoading.value = false
          emit('load-next')
          emit('is-ready')
        })
        return { imageLoading, error, isLoading, isReady }
      }
    }

    return {
      imageLoading,
      imageError
    }
  },
  emits: ['load-next', 'is-ready'],
  props: {
    image: {
      type: Object as PropType<AsyncImageData | undefined>,
      required: true
    },
    currentImageIndexToLoad: {
      type: Number,
      default: 0
    },
    showImages: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentImageIndexToLoad(newValue, oldValue) {
      if (newValue == this.image?.index) {
        this.loadImage()
      }
    }
  },
  methods: {
    async loadImage() {
      try {
        if (this.image) {
          const { isLoading, state, isReady, error } = useImage({ src: this.image?.url })

          this.$nextTick(() => {
            this.imageLoading = isLoading as unknown as boolean
            this.imageError = error
            this.$emit('load-next')
            this.$emit('is-ready')
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  components: { LoadingComponent }
})
</script>
<style scoped>
.loading-container {
  background-color: white;
}
</style>
